
    // this file was auto generated by python script
    // this icon was sourced from feather icons 4.2.8
    import React from 'react';
    const AtSign = () => (
      <>
        <circle cx="12" cy="12" r="4"></circle><path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94"></path>
      </>
    );
    export default AtSign;
    